
import { Vue, Component, Watch, Prop, Model } from 'vue-property-decorator';
import moment, { Moment } from 'moment';

@Component({})
export default class StartTimeField extends Vue {
  val: any = null;

  @Prop()
  placeholder?: string;

  @Model('change', {
    type: String,
  })
  value!: string;

  @Watch('val')
  watchInternalVal(): void {
    if (this.val === null) {
      this.$emit('change', '');
    } else {
      const year = `${this.val[0].format('YYYY-MM-DD')}~${this.val[1].format('YYYY-MM-DD')}`;
      this.$emit('change', year);
    }

    this.$emit('updateSubmittable', this.val !== null);
  }

  @Watch('value')
  watchValue() {
    if (!this.value || this.value === '') {
      this.val = null;
      return;
    }
    const year = this.value.split('~');
    this.val = [moment(year[0]), moment(year[1])];
  }

  onPanelChange(val: Moment) {
    this.val = val;
  }

  mounted() {
    this.watchValue();
  }
}
